export default __webpack_public_path__ + "static/media/fbicon.0f7789b1.svg";